/**
 * <StudentHeader
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import locale from './locale';
import StudentModalHeader from 'components/UI/StudentModalHeader';
import __R, { userCan } from 'containers/__R'
import TeacherDescriptionModal from 'template/Modals/TeacherDescription'

import WALLET from 'icons/wallet.png';
import PENCIL from 'icons/pencil.png';

import { connect } from 'react-redux'

const mapStateToProps = (state) => ({
  user: state.user,
});

class TeacherHeader extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }

  render() {
    const {
      teacher = {},
      onClickPayment,
      onClickEdit,
      user,
    } = this.props;
    const teacherLoaded = typeof teacher.id !== 'undefined';

    return (
      <div className='studentInfoDockHeader'>
        <StudentModalHeader name={teacher.name} gender={teacher.gender} profilePhoto={teacher.profilePhotoThumbnail8x} profileThumbnail={teacher.profilePhotoThumbnail2x} type='teacher' />

        <div className='studentInfoHeaderBtn'>

          {/* temporary testing modal */}
          {process.env.APP_ENV === 'development' && <__R can='edit_teacher' by='disable'><button className='btn' disabled={teacher.archived} onClick={() => {
            TeacherDescriptionModal({id: teacher.id})
          }}>{__('Teacher Description', locale)}</button></__R>}

          { teacherLoaded && <__R can='edit_teacher' by='disable'>
             <button className='btn' disabled={teacher.archived} onClick={onClickEdit}>{__('Edit', locale)}</button>
          </__R> }

        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(TeacherHeader);



// WEBPACK FOOTER //
// ./src/template/Docks/TeacherInfo/TeacherHeader.js